/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MaxInputs */

const en_max = /** @type {(inputs: MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const de_max = /** @type {(inputs: MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

/**
* | output |
* | --- |
* | "Max" |
*
* @param {MaxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const max = /** @type {((inputs?: MaxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MaxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_max(inputs)
	return de_max(inputs)
});